import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import http from './plugins/http.js'
import utils from './plugins/utils.js'

Vue.config.productionTip = false;
Vue.prototype.$axios = http;
Vue.prototype.$utils = utils;

new Vue({
    data() {
        return {
            token: "",
            alias: "",
            account: "",
            role: "",
            code: "",
            customers: [],
            businesses: []
        }
    },
    computed: {
        isSupper() {
            return this.role === "ADMIN" && (this.account === "admins"
                || this.account === "rivenhong"
                || this.account === "wblu"
                || this.account === "jonathan");
        },
        isAdmin() {
            return this.role === "ADMIN";
        },
        isOperation() {
            return this.account === "elenazhang" || this.account === "zoeyyao";
        },
        couldExport() {
            if (this.isOperation) {
                return false;
            }

            return this.isAdmin;
        }
    },
    mounted() {
        Object.assign(this.$data, JSON.parse(sessionStorage.getItem("context")));
        if (this.role) {
            this.refreshCustomer();
            this.refreshBusiness();
        }
    },
    methods: {
        getCustomerName(code) {
            let name = "";
            this.customers.forEach(customer => {
                if (code.indexOf(customer.value) === 0) {
                    name = customer.label;
                    return false;
                }
            });
            return name;
        },
        getBusinessName(code) {
            let name = "";
            this.businesses.forEach(business => {
                if (code.indexOf(business.value) === 0) {
                    name = business.label;
                    return false;
                }
            });
            return name;
        },
        async refreshCustomer() {
            if (this.isAdmin) {
                await this.$axios.get("/customer/list").then(customers => {
                    this.customers = [];
                    customers.forEach(customer => {
                        this.customers.push({value: customer.code, label: customer.companyName});
                    });
                })
            } else {
                this.customers = [{value: this.code, label: this.alias}];
            }
        },
        async refreshBusiness() {
            await this.$axios.get("/business/list").then(businesses => {
                this.businesses = [];
                businesses.forEach(business => {
                    this.businesses.push({value: business.code, label: business.name, account: business.account});
                });
            })
        },

    },
    router,
    render: h => h(App)
}).$mount('#app');
